import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from '../../../../../../../core/data/GraphQLApi';
import { endpoints } from '../../../../../../../core/defaultValues';
import { ExceptionManager } from '../../../../../../../core/logManager';

import { resetALL } from '../../../../../../../.globals/redux/actions';

//STATE INITIAL
const INIT_STATE = {
    error: null,
    unit: null,
    open: false,
    loading: false,
    units: [],
    pairing: null,
    unPairing: null
};

const route = 'modules/manage/views/cameraManagementTab/modals/editCameraManagementPairing/redux/slice'

export const editCameraManagementSearchUnits = createAsyncThunk('cameraManagementTab/editCameraManagementPairing/editCameraManagementSearchUnits', async (payload, { rejectWithValue, dispatch }) => {
    try {
        const response = await clientQuery(
            `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                data: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        linkedUnitId
                        linkedUnit {
                            id
                            label
                            esn
                            imei
                        }
                        deviceModel {
                            manufacturer {
                                name
                            }
                        }
                        linkedByUnitId
                        linkedByUnit {
                            id
                            label
                        }
                    }
                    total
                }
            }
            `,
            {
                conditions: [],
                limit: 30000,
                offset: 0,
                sort: {
                    field: "label",
                    order: "ASC"
                }
            },
            endpoints.GRAPHQL_GENERAL_V2
        );
        return response?.data || { items: [], total: 0 };
    } catch (exc) {
        ExceptionManager(exc, route, 'editCameraManagementSearchUnits');
        return rejectWithValue(exc)
    }
});

export const editCameraManagementBulkPairing = createAsyncThunk('cameraManagementTab/editCameraManagementPairing/editCameraManagementBulkPairing', async (payload, { rejectWithValue, dispatch }) => {
    try {
        const response = await clientMutation(
            `mutation bulkPairing ($pairing: [BulkPairingInput]) {
                result: bulkPairing (pairing: $pairing) {
                    unitIdCamera
                    unitIdGps
                    errorMessage
                    errorCode
                }
            }`,
            {
                pairing: payload
            },
            endpoints.GRAPHQL_GENERAL_V2
        );
        return response?.result
    } catch (exc) {
        ExceptionManager(exc, route, 'editCameraManagementBulkPairing');
        return rejectWithValue(exc)
    }
});

export const editCameraManagementBulkUnPairing = createAsyncThunk('cameraManagementTab/editCameraManagementPairing/editCameraManagementBulkUnPairing', async (payload, { rejectWithValue, dispatch }) => {
    try {
        const response = await clientMutation(
            `mutation bulkUnpairing ($unitIds: [Int]) {
                result: bulkUnpairing (unitIds: $unitIds)
            }`,
            {
                unitIds: payload
            },
            endpoints.GRAPHQL_GENERAL_V2
        );
        return { result: response?.result }
    } catch (exc) {
        ExceptionManager(exc, route, 'editCameraManagementBulkUnPairing');
        return rejectWithValue(exc)
    }
});

const editCameraManagementPairingRedux = createSlice({
    name: 'cameraManagementTab/editCameraManagementPairing',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE
        },
        openModalEditCameraManagementPairing(state, action) {
            return { ...state, open: action?.payload?.open, unit: action?.payload?.unit }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //editCameraManagementSearchUnits
        builder.addCase(editCameraManagementSearchUnits.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(editCameraManagementSearchUnits.fulfilled, (state, action) => {
            state.units = action.payload.items || []
            state.loading = false;
        });
        builder.addCase(editCameraManagementSearchUnits.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

        //editCameraManagementBulkPairing
        builder.addCase(editCameraManagementBulkPairing.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(editCameraManagementBulkPairing.fulfilled, (state, action) => {
            state.pairing = action.payload
            state.loading = false;
        });
        builder.addCase(editCameraManagementBulkPairing.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

        //editCameraManagementBulkUnPairing
        builder.addCase(editCameraManagementBulkUnPairing.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(editCameraManagementBulkUnPairing.fulfilled, (state, action) => {
            state.unPairing = action.payload
            state.loading = false;
        });
        builder.addCase(editCameraManagementBulkUnPairing.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = editCameraManagementPairingRedux;

// Extract and export each action creator by name
export const { reset, openModalEditCameraManagementPairing } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;